import { Helmet } from 'react-helmet-async';
import { Container, FormControlLabel, Stack, Switch, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { getLobbySettings, updateLobbySettings } from '../services/Common/lobby.service';

export default function LobbyPage() {
    const [form, setForm] = useState({ name: 'Lobby', enabled: true, welcomeMessage: '' });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getLobbySettings()
            .then((data) => setForm({
                name: data?.name || 'Lobby',
                enabled: data?.enabled !== false,
                welcomeMessage: data?.welcomeMessage || ''
            }))
            .catch(() => toast('Failed to load Lobby settings', { type: 'error' }));
    }, []);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            await updateLobbySettings(form);
            toast('Lobby settings updated', { type: 'success' });
        } catch (_) {
            toast('Failed to update Lobby settings', { type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Helmet><title>Lobby | Trooper</title></Helmet>
            <Container>
                <Typography variant="h4" gutterBottom>Public Lobby</Typography>
                <Stack spacing={3} sx={{ maxWidth: 560, mt: 3 }}>
                    <FormControlLabel
                        control={<Switch checked={form.enabled} onChange={(e) => setForm({ ...form, enabled: e.target.checked })} />}
                        label="Show Lobby in the mobile app"
                    />
                    <TextField
                        label="Lobby name"
                        value={form.name}
                        onChange={(e) => setForm({ ...form, name: e.target.value })}
                        fullWidth
                    />
                    <TextField
                        label="Welcome message"
                        value={form.welcomeMessage}
                        onChange={(e) => setForm({ ...form, welcomeMessage: e.target.value })}
                        multiline
                        minRows={3}
                        fullWidth
                    />
                    <LoadingButton variant="contained" size="large" loading={loading} onClick={handleSubmit}>
                        Save Lobby Settings
                    </LoadingButton>
                </Stack>
            </Container>
        </>
    );
}
